<span>
  @if (showOnlySymbol) {
    {{ currencySymbol }}
  } @else if (showOnlyNumber) {
    {{ amount | currency: currencyCode : ' ' : format }}
  } @else if (showSymbol) {
    {{ currencySymbol }} {{ amount | currency: currencyCode : ' ' : format }}
  } @else {
    {{ amount | currency: currencyCode : 'symbol' : format }}
  }
</span>
